export type Quality = "480p" | "720p" | "1080p" | "4K";
export type DownloadLink = {
  quality: Quality;
  size: string;
  server: string;
  url: string;
  /** "watch" = online streaming link, "download" = direct download. Defaults to "download". */
  kind?: "watch" | "download";
};
/** ISO country code (e.g. US, GB, DE, FR, TR, KR, JP, EG, SA, AE…) */
export type CountryCode = string;
export type Movie = {
  id: string;
  slug: string;
  title: string;
  titleEn: string;
  titleFr?: string;
  type: "movie" | "series";
  year: number;
  releaseDate?: string;
  firstAirDate?: string;
  lastAirDate?: string;
  status?: string;
  statusEn?: string;
  statusFr?: string;
  rating: number;
  duration: string;
  /** Optional localized duration strings; if absent we fall back to `duration`. */
  durationEn?: string;
  durationFr?: string;
  /** Series only — localized season label, e.g. "3 مواسم" / "3 seasons" / "3 saisons". */
  seasonInfo?: string;
  seasonInfoEn?: string;
  seasonInfoFr?: string;
  genres: string[];
  genresEn: string[];
  genresFr?: string[];
  poster: string;
  backdrop: string;
  overview: string;
  overviewEn: string;
  overviewFr?: string;
  cast: string[];
  director: string;
  trailer: string;
  /** Pre-encrypted double-layer protected token (replaces watch_url). */
  watchToken?: string;
  downloads: DownloadLink[];
  country?: CountryCode;
  isNew?: boolean;
  isTrending?: boolean;
  /** Preserved from content JSON for round-trip on republish. */
  tags?: string[];
  /** Series only — number of seasons (required by content schema). */
  seasonsCount?: number;
  /** Movie only — opaque video source descriptor (required by content schema). */
  videoSource?: { type: "mp4" | "m3u8" | "external"; source_id: string; source_url?: string; protected?: true };
  /** Optional duration in minutes (from schema). Preserved on round-trip. */
  durationMinutes?: number;
  /**
   * Raw source JSON captured from /content when this Movie was loaded via
   * the adapter. Used ONLY by the dashboard's `toMovieJson()` to preserve
   * every field on republish — never rendered.
   */
  __raw?: Record<string, unknown>;
};
const img = (seed: string, w = 400, h = 600) =>
  `https://picsum.photos/seed/${encodeURIComponent(seed)}/${w}/${h}`;
export const MOVIES: Movie[] = [];
export const getMovieBySlug = (slug: string) => MOVIES.find((m) => m.slug === slug);
export const getTrending = () => MOVIES.filter((m) => m.isTrending);
export const getNew = () => MOVIES.filter((m) => m.isNew);
export const getMovies = () => MOVIES.filter((m) => m.type === "movie");
export const getSeries = () => MOVIES.filter((m) => m.type === "series");
